import React from "react";
import {
  CATEGORY,
  FORM_CONSTANTS,
  KEYS,
  RESEARCH_CONSTANTS,
  REPORTS_CONSTANTS,
  MONOGRAPHS_CONSTANTS,
  TECH_COMPANY_CONSTANTS,
  SOLUTIONS_CONSTANTS,
  REWARD_CONSTANTS,
  RESEARCHPROJECTS_CONSTANTS,
} from "../../constants";
import { Button } from "@material-ui/core";
import { fileRender } from "../photoRender";
import { resolveQcvLabel } from "../qcvScoreOptions";
import { QCV2026_REWARD_LEVEL_OPTIONS } from "../../constants/qcv2026.config";

const {
  ROLE_OPTIONS,
  levelOptions,
  ALL_TYPE_OPTIONS,
} = FORM_CONSTANTS;

// Link file minh chứng của thành tích. AI XEM ĐƯỢC HỒ SƠ THÌ XEM ĐƯỢC CỘT NÀY
// — kể cả hội đồng bình chọn (cần đọc minh chứng để bỏ phiếu) và chính ứng viên
// (file của họ). Đây là dữ liệu ứng viên khai, KHÔNG phải kết quả chấm điểm.
export const hoSoEvidenceColumn = {
  title: <b>Tác vụ</b>,
  dataIndex: 'link',
  width: '15%',
  render: (value, row) => (
    <a
      target='_blank'
      rel='noreferrer'
      href={value || fileRender(row?.preview || row?.link)}
    >
      Minh chứng
    </a>
  ),
};

// Điểm & ghi chú của ban thư ký — CHỈ người có quyền chấm/duyệt được thấy
// (xem canReviewQcv). Đừng gộp cột minh chứng vào đây nữa.
export const hoSoScoreColumns = [
  { title: <b>Điểm</b>, dataIndex: 'score', width: '10%' },
  { title: <b>Ghi chú</b>, dataIndex: 'note', width: '20%' },
];

// Giữ lại cho tương thích, thứ tự y như trước: Điểm, Ghi chú, Tác vụ.
export const hoSoDefaultColumns = [...hoSoScoreColumns, hoSoEvidenceColumn];

const _hoSoColumnMap = {
  formTechCompany: (scoreInformationList) => [
    { title: <b>Tên sản phẩm</b>, dataIndex: 'production', width: '30%', render: (v, _, i) => `${i + 1}. ${v}` },
    { title: <b>PL</b>, dataIndex: 'applicationRange', width: '25%', render: (value) => resolveQcvLabel(scoreInformationList, '6', TECH_COMPANY_CONSTANTS.productionOptions, value) },
  ],
  formSolution: (scoreInformationList) => [
    { title: <b>Tên sản phẩm</b>, dataIndex: 'title', width: '25%', render: (v, _, i) => `${i + 1}. ${v}` },
    { title: <b>PL</b>, dataIndex: 'type', width: '25%', render: (value) => resolveQcvLabel(scoreInformationList, '1', SOLUTIONS_CONSTANTS.TYPE_OPTIONS, value) },
    { title: <b>Tác Giả</b>, dataIndex: 'author', width: '25%' },
  ],
  formResearchProject: (scoreInformationList) => [
    { title: <b>Tên sản phẩm</b>, dataIndex: 'title', width: '20%', render: (v, _, i) => `${i + 1}. ${v}` },
    { title: <b>PL</b>, dataIndex: 'level', width: '20%', render: (value) => resolveQcvLabel(scoreInformationList, '4', RESEARCHPROJECTS_CONSTANTS.LEVEL_OPTIONS, value) },
    { title: <b>Vai trò</b>, dataIndex: 'type', width: '20%', render: (value) => ALL_TYPE_OPTIONS.find((opt) => opt.value === value)?.title },
  ],
  formReward: (scoreInformationList) => [
    { title: <b>Tên giải thưởng</b>, dataIndex: 'title', width: '20%', render: (v, _, i) => `${i + 1}. ${v}` },
    { title: <b>PL</b>, dataIndex: 'type', width: '25%', render: (value) => resolveQcvLabel(scoreInformationList, '7', REWARD_CONSTANTS.typeOptions, value) },
  ],
  formMonograph: (scoreInformationList) => [
    { title: <b>Tên sách</b>, dataIndex: 'title', width: '40%', render: (v, _, i) => `${i + 1}. ${v}` },
    {
      title: <b>PL</b>,
      dataIndex: 'type',
      width: '30%',
      render: (value) => resolveQcvLabel(
        scoreInformationList,
        '5',
        [...MONOGRAPHS_CONSTANTS.TYPE_OPTIONS.INTERNATIONAL, ...MONOGRAPHS_CONSTANTS.TYPE_OPTIONS.DOMESTIC],
        value
      ),
    },
    { title: <b>Vai trò</b>, dataIndex: 'role', width: '30%', render: (value) => ROLE_OPTIONS.find((opt) => opt.value === value)?.title },
  ],
  formHrDevelopmentdaoTao: () => [
    { title: <b>Tên học viên</b>, dataIndex: 'traineeName', width: '30%', render: (v, _, i) => `${i + 1}. ${v}` },
    { title: <b>Chương trình đào tạo</b>, dataIndex: 'academicLevel', width: '25%', render: (value) => levelOptions.find((opt) => opt.value === value)?.title },
  ],
  formHrDevelopmentboiDuong: () => [
    { title: <b>Tên chương trình</b>, dataIndex: 'programName', width: '30%', render: (v, _, i) => `${i + 1}. ${v}` },
    { title: <b>Số lượng nhân lực được bồi dưỡng</b>, dataIndex: 'traineeNum', width: '25%' },
  ],
  formScientificResearch: (scoreInformationList) => [
    { title: <b>Nội dung</b>, dataIndex: 'title', width: '25%', render: (v, _, i) => `${i + 1}. ${v}` },
    {
      title: <b>PL</b>,
      dataIndex: 'type',
      width: '10%',
      render: (value) => resolveQcvLabel(
        scoreInformationList,
        '2',
        [...RESEARCH_CONSTANTS.TYPE_OPTIONS.INTERNATIONAL, ...RESEARCH_CONSTANTS.TYPE_OPTIONS.DOMESTIC],
        value
      ),
    },
    { title: <b>Số TG</b>, dataIndex: 'numberAuthor', width: '10%' },
    { title: <b>Vai trò</b>, dataIndex: 'role', width: '10%', render: (value) => ROLE_OPTIONS.find((opt) => opt.value === value)?.title },
  ],
  formScientificReport: (scoreInformationList) => [
    { title: <b>Nội dung</b>, dataIndex: 'title', width: '25%', render: (v, _, i) => `${i + 1}. ${v}` },
    { title: <b>PL</b>, dataIndex: 'type', width: '10%', render: (value) => resolveQcvLabel(scoreInformationList, '3', REPORTS_CONSTANTS.TYPE_OPTIONS.ALL, value) },
    { title: <b>Số TG</b>, dataIndex: 'numberAuthor', width: '10%' },
    { title: <b>Vai trò</b>, dataIndex: 'role', width: '10%', render: (value) => ROLE_OPTIONS.find((opt) => opt.value === value)?.title },
  ],
  // ??
  hocTapCongTac: () => [
    { title: <b>Thời gian bắt đầu</b>, dataIndex: "startAt", width: "25%", },
    { title: <b>Thời gian kết thúc</b>, dataIndex: "finishAt", width: "25%" },
    { title: <b>Đơn vị công tác</b>, dataIndex: "department", width: "25%" },
    { title: <b>Công việc đảm nhiệm</b>, dataIndex: "works", width: "25%" },
  ],
  thanhTichBangKhen: (callback) => [
    { title: <b>Nội dung khen thưởng</b>, dataIndex: "achievementContent", width: "50%" },
    {
      title: <b>Cấp khen thưởng</b>,
      dataIndex: "typeOfAchievement",
      width: "30%",
      // QCV 2026 lưu cấp khen thưởng theo QCV2026_REWARD_LEVEL_OPTIONS
      // (nha_nuoc/bo_nganh_tinh); vẫn fallback LEVEL_INPUT_OPTIONS cho dữ liệu cũ.
      render: (value) =>
        QCV2026_REWARD_LEVEL_OPTIONS.find((lvl) => lvl.value === value)?.title ||
        FORM_CONSTANTS.LEVEL_INPUT_OPTIONS.find((lvl) => lvl.value === value)?.title ||
        "",
    },
    {
      title: <b>Minh Chứng</b>,
      dataIndex: 'achievementFile',
      width: '20%',
      render: (value) => (
        <Button color="primary" style={{ textTransform: 'none' }} onClick={() => callback(value)}>
          Chi tiết
        </Button>
      ),
    },
  ],
  hoatDongCongDong: (callback) => [
    {
      title: <b>Mô tả</b>,
      dataIndex: 'communityAchievement',
      width: '80%',
      render: (value) => value,
    },
    {
      title: <b>Minh Chứng</b>,
      dataIndex: 'communityAchievementFile',
      width: '20%',
      render: (value) => (
        <Button
          color="primary"
          style={{ textTransform: 'none' }}
          onClick={() => callback(value)}
        >
          Chi tiết
        </Button>
      ),
    },
  ],
  // C.1 Hoạt động bồi dưỡng nhân lực (đồng bộ với form: content + hrTrainingFile)
  boiDuongNhanLuc: (callback) => [
    {
      title: <b>Hình thức và nội dung thành tích</b>,
      dataIndex: 'content',
      width: '80%',
      render: (value) => value,
    },
    {
      title: <b>Minh Chứng</b>,
      dataIndex: 'hrTrainingFile',
      width: '20%',
      render: (value) =>
        value ? (
          <Button
            color="primary"
            style={{ textTransform: 'none' }}
            onClick={() => callback(value)}
          >
            Chi tiết
          </Button>
        ) : null,
    },
  ],
};

export const hoSoColumnMap = {
  QCV: _hoSoColumnMap,
  [CATEGORY.KVC]: {
    hocTapCongTac: _hoSoColumnMap.hocTapCongTac,
    thanhTichBangKhen: (callback) => [
      { title: <b>Nội dung khen thưởng</b>, dataIndex: `${KEYS.OTHER_ACHIEVEMENT}Content`, width: "50%" },
      {
        title: <b>Cấp khen thưởng</b>,
        dataIndex: `${KEYS.OTHER_ACHIEVEMENT}Type`,
        width: "30%",
        render: (value) => FORM_CONSTANTS.LEVEL_INPUT_OPTIONS.find((lvl) => lvl.value === value)?.title || "",
      },
      {
        title: <b>Minh Chứng</b>,
        dataIndex: `${KEYS.OTHER_ACHIEVEMENT}PreviewFile`,
        width: '20%',
        render: (value) => (
          <Button color="primary" style={{ textTransform: 'none' }} onClick={() => callback(value)}>
            Chi tiết
          </Button>
        ),
      },
    ],
    hoatDongChiaSeTriThuc: (callback) => [
      { title: <b>Mô tả</b>, dataIndex: `${KEYS.PERSONAL_ACHIEVEMENT}Content`, width: '80%' },
      {
        title: <b>Minh Chứng</b>,
        dataIndex: `${KEYS.PERSONAL_ACHIEVEMENT}PreviewFile`,
        width: '20%',
        render: (value) => (
          <Button
            color="primary"
            style={{ textTransform: 'none' }}
            onClick={() => callback(value)}
          >
            Chi tiết
          </Button>
        ),
      },
    ],
    hoatDongCongDong: (callback) => [
      { title: <b>Mô tả</b>, dataIndex: `${KEYS.SOCIAL_ACTIVITY}Content`, width: '80%' },
      {
        title: <b>Minh Chứng</b>,
        dataIndex: `${KEYS.SOCIAL_ACTIVITY}PreviewFile`,
        width: '20%',
        render: (value) => (
          <Button
            color="primary"
            style={{ textTransform: 'none' }}
            onClick={() => callback(value)}
          >
            Chi tiết
          </Button>
        ),
      },
    ],
    formScientificResearch: _hoSoColumnMap.formScientificResearch,
    formScientificReport: _hoSoColumnMap.formScientificReport,
    formMonograph: _hoSoColumnMap.formMonograph,
  },
  [CATEGORY.GTNS]: {
    thanhTichBangKhen: (callback) => [
      { title: <b>Nội dung khen thưởng</b>, dataIndex: `${KEYS.REWARD}Content`, width: "50%" },
      {
        title: <b>Cấp khen thưởng</b>,
        dataIndex: `${KEYS.REWARD}Type`,
        width: "30%",
        render: (value) => FORM_CONSTANTS.LEVEL_INPUT_OPTIONS.find((lvl) => lvl.value === value)?.title || "",
      },
      {
        title: <b>Minh Chứng</b>,
        dataIndex: `${KEYS.REWARD}PreviewFile`,
        width: '20%',
        render: (value) => (
          <Button color="primary" style={{ textTransform: 'none' }} onClick={() => callback(value)}>
            Chi tiết
          </Button>
        ),
      },
    ],
    thanhTichChuyenNganh: (callback) => [
      { title: <b>Hình thức và nội dung thành tích</b>, dataIndex: `${KEYS.MAJOR_ACHIEVEMENT}Content`, width: "50%" },
      {
        title: <b>Cấp thành tích</b>,
        dataIndex: `${KEYS.MAJOR_ACHIEVEMENT}Type`,
        width: "30%",
        render: (value) => FORM_CONSTANTS.LEVEL_INPUT_OPTIONS.find((lvl) => lvl.value === value)?.title || "",
      },
      {
        title: <b>Minh Chứng</b>,
        dataIndex: `${KEYS.MAJOR_ACHIEVEMENT}PreviewFile`,
        width: '20%',
        render: (value) => (
          <Button color="primary" style={{ textTransform: 'none' }} onClick={() => callback(value)}>
            Chi tiết
          </Button>
        ),
      },
    ],
    hoatDongCongDong: (callback) => [
      { title: <b>Mô tả</b>, dataIndex: `${KEYS.SOCIAL_ACTIVITY}Content`, width: '80%' },
      {
        title: <b>Minh Chứng</b>,
        dataIndex: `${KEYS.SOCIAL_ACTIVITY}PreviewFile`,
        width: '20%',
        render: (value) => (
          <Button
            color="primary"
            style={{ textTransform: 'none' }}
            onClick={() => callback(value)}
          >
            Chi tiết
          </Button>
        ),
      },
    ],
  }
};